/* Auto-generated store location dataset. Do not edit directly. */
window.enduristanStores = [
  {
    "id": "loc_3g9xe587",
    "name": "Swissmotoshop by Swissimpex Sàrl",
    "address1": "Rte du Village 23",
    "address2": "",
    "city": "Vucherens",
    "state": "",
    "postal": "1509",
    "country": "Switzerland",
    "phone": "+41 79 828 23 23",
    "email": "info@swissmotoshop.ch",
    "website": "http://www.swissmotoshop.ch",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": false,
    "sources": [
      "stockist-locations-ch.csv"
    ],
    "lng": 6.777319,
    "lat": 46.624839
  },
  {
    "id": "loc_3xpe5ze6",
    "name": "Andrey Cycle Shop et Machines SA",
    "address1": "Route du Closalet 26",
    "address2": "",
    "city": "La Tour-de-Trême",
    "state": "",
    "postal": "1635",
    "country": "Switzerland",
    "phone": "",
    "email": "vente@andrey-cm.ch",
    "website": "http://www.andrey-cm.ch",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": false,
    "sources": [
      "stockist-locations-ch.csv"
    ],
    "lng": 7.077081,
    "lat": 46.600636
  },
  {
    "id": "loc_4yzjx2xv",
    "name": "VTR Motorrad",
    "address1": "St. Gallerstrasse 77",
    "address2": "",
    "city": "Schmerikon",
    "state": "",
    "postal": "8716",
    "country": "Switzerland",
    "phone": "+41 55 282 15 16",
    "email": "info@stucki-schmerikon.ch",
    "website": "http://www.stucki-schmerikon.ch",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": false,
    "sources": [
      "stockist-locations-ch.csv"
    ],
    "lng": 8.962241,
    "lat": 47.230225
  },
  {
    "id": "loc_4wk7w57x",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Denmark",
    "phone": "",
    "email": "info@enduristan.dk",
    "website": "http://www.enduristan.dk",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 10.046297,
    "lat": 55.963398
  },
  {
    "id": "loc_4zrq98nw",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "USA",
    "phone": "",
    "email": "hello@enduristan-usa.com",
    "website": "http://www.enduristan-usa.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": -100.445882,
    "lat": 39.7837304
  },
  {
    "id": "loc_46grp6e5",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Iceland",
    "phone": "",
    "email": "magnus@nitro.is",
    "website": "http://www.nitro.is",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": -18.1059013,
    "lat": 64.9841821
  },
  {
    "id": "loc_3rep9ngq",
    "name": "In-Parts",
    "address1": "Rua da Liberdade Nr. 80 Perofilho",
    "address2": "",
    "city": "Santarem",
    "state": "",
    "postal": "2005-008",
    "country": "Portugal",
    "phone": "+351 243 499 255",
    "email": "vendas@in-parts.com",
    "website": "http://www.in-parts.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv"
    ],
    "lng": -8.7247833,
    "lat": 39.1879634
  },
  {
    "id": "loc_45v86nqn",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Spain",
    "phone": "",
    "email": "hola@enduristan.es",
    "website": "https://www.enduristan.es/",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": -4.8379791,
    "lat": 39.3260685
  },
  {
    "id": "loc_48zmn956",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "United Kingdom",
    "phone": "",
    "email": "andy@enduristan.co.uk",
    "website": "http://www.enduristan.co.uk",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": -3.2765753,
    "lat": 54.7023545
  },
  {
    "id": "loc_47j6w76q",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "France",
    "phone": "",
    "email": "bonjour@enduristan.fr",
    "website": "http://www.enduristan.fr",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 1.8883335,
    "lat": 46.603354
  },
  {
    "id": "loc_3vzqpgqm",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Netherlands",
    "phone": "",
    "email": "hello@enduristan.nl",
    "website": "https://enduristan.nl/",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 5.6343227,
    "lat": 52.2434979
  },
  {
    "id": "loc_3qgk7wky",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Luxemburg",
    "phone": "",
    "email": "eu@enduristan.com",
    "website": "https://www.enduristan.eu",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 6.1296751,
    "lat": 49.8158683
  },
  {
    "id": "loc_4k6xpnxq",
    "name": "MotoNuba",
    "address1": "Oberes Stengeli 3",
    "address2": "",
    "city": "Schwarzenburg",
    "state": "",
    "postal": "3150",
    "country": "Switzerland",
    "phone": "+41 79 175 15 32",
    "email": "motonuba@outlook.com",
    "website": "http://www.motonuba.ch",
    "notes": "Termin auf Anfrage / Date on request",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv"
    ],
    "lng": 7.3394778,
    "lat": 46.8155556
  },
  {
    "id": "loc_4y2v7kvv",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Monaco",
    "phone": "",
    "email": "bonjour@enduristan.fr",
    "website": "http://www.enduristan.fr",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 7.4276832,
    "lat": 43.7323492
  },
  {
    "id": "loc_48v8e5v6",
    "name": "Phoenix Basel AG",
    "address1": "Reinacherstr. 80-84",
    "address2": "",
    "city": "Basel",
    "state": "",
    "postal": "4053",
    "country": "Switzerland",
    "phone": "+41613227978",
    "email": "info@phoenixbasel.ch",
    "website": "http://phoenixbasel.ch",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv"
    ],
    "lng": 7.6030356,
    "lat": 47.5397004
  },
  {
    "id": "loc_469zmgz5",
    "name": "Moto Mader AG",
    "address1": "Ausserfeldstrasse 20",
    "address2": "",
    "city": "Oberentfelden",
    "state": "",
    "postal": "5036",
    "country": "Switzerland",
    "phone": "+41627378585",
    "email": "info@moto-mader.ch",
    "website": "http://www.moto-mader.ch",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv"
    ],
    "lng": 8.0576956,
    "lat": 47.3542962
  },
  {
    "id": "loc_exzr9pzv",
    "name": "Zweirad-Sport Wirz AG",
    "address1": "Seetalstrasse 8",
    "address2": "",
    "city": "Schafisheim",
    "state": "",
    "postal": "5503",
    "country": "Switzerland",
    "phone": "+41 62 891 36 49",
    "email": "info@wirz-bike.ch",
    "website": "https://wirz-bike.ch/",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 8.1365687,
    "lat": 47.385768
  },
  {
    "id": "loc_4pkjnpjk",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Switzerland",
    "phone": "",
    "email": "hallo@enduristan.ch",
    "website": "http://www.enduristan.ch",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 8.2319736,
    "lat": 46.7985624
  },
  {
    "id": "loc_48y86z86",
    "name": "MotoCenter Seetal",
    "address1": "Luzernstrasse 15",
    "address2": "",
    "city": "Hochdorf",
    "state": "",
    "postal": "6280",
    "country": "Switzerland",
    "phone": "+41 41 448 33 63",
    "email": "info@motocenter-seetal.ch",
    "website": "http://www.motocenter-seetal.ch",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv"
    ],
    "lng": 8.296626,
    "lat": 47.1656623
  },
  {
    "id": "loc_39r82vxy",
    "name": "Hedin Automotive Dielsdorf",
    "address1": "Industriestrasse 6",
    "address2": "",
    "city": "Dielsdorf",
    "state": "",
    "postal": "8157",
    "country": "Switzerland",
    "phone": "0582697100",
    "email": "zubehoer.dielsdorf@hedinautomotive.ch",
    "website": "https://www.bmw-motorrad.ch/hedin-dielsdorf/de/home.html",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv"
    ],
    "lng": 8.4636207,
    "lat": 47.4833093
  },
  {
    "id": "loc_47gkzjzq",
    "name": "moto 91",
    "address1": "Grabackerstrasse 1",
    "address2": "",
    "city": "Höri",
    "state": "",
    "postal": "8181",
    "country": "Switzerland",
    "phone": "+41 44 862 11 91",
    "email": "info@moto91.ch",
    "website": "http://www.moto91.ch",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv"
    ],
    "lng": 8.5175906,
    "lat": 47.5105425
  },
  {
    "id": "loc_3vmn2z2m",
    "name": "3W Motosport",
    "address1": "Weiachstrasse 90",
    "address2": "",
    "city": "Neftenbach",
    "state": "",
    "postal": "8413",
    "country": "Switzerland",
    "phone": "+41523153188",
    "email": "info@3w-motosport.ch",
    "website": "http://www.3w-motosport.ch",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv"
    ],
    "lng": 8.6640513,
    "lat": 47.5180938
  },
  {
    "id": "loc_3qzv6g6y",
    "name": "Gubi's Motoshop",
    "address1": "Aretshaldenstrasse 17",
    "address2": "",
    "city": "Aathal-Seegräben",
    "state": "",
    "postal": "8607",
    "country": "Switzerland",
    "phone": "+41 79 353 31 27",
    "email": "wgubi@teneretraveler.ch",
    "website": "http://www.gubis-motoshop.ch",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv"
    ],
    "lng": 8.7711853,
    "lat": 47.3354704
  },
  {
    "id": "loc_4n8jpqj5",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Norway",
    "phone": "",
    "email": "post@enduristan.no",
    "website": "http://www.enduristan.no",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 8.7876653,
    "lat": 61.1529386
  },
  {
    "id": "loc_325x96x9",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Germany",
    "phone": "",
    "email": "kontakt@enduristan.de",
    "website": "http://www.enduristan.de",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 10.4478313,
    "lat": 51.1638175
  },
  {
    "id": "loc_3jxg95ge",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "San Marino",
    "phone": "",
    "email": "richieste@enduristan.it",
    "website": "http://www.enduristan.it",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 12.458306,
    "lat": 43.9458623
  },
  {
    "id": "loc_3ezwjnwv",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Italy",
    "phone": "",
    "email": "richieste@enduristan.it",
    "website": "http://www.enduristan.it",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 12.674297,
    "lat": 42.6384261
  },
  {
    "id": "loc_3g8g6eg7",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Austria",
    "phone": "",
    "email": "kontakt@enduristan.at",
    "website": "https://enduristan.at",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 14.12456,
    "lat": 47.59397
  },
  {
    "id": "loc_45jry6rn",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Slovenia",
    "phone": "",
    "email": "hello@enduristan.si",
    "website": "http://www.enduristan.si",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 14.8153333,
    "lat": 46.1199444
  },
  {
    "id": "loc_3mnjyvjv",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Czech Republic",
    "phone": "",
    "email": "info@enduristan.cz",
    "website": "http://www.enduristan.cz",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 15.3381061,
    "lat": 49.7439047
  },
  {
    "id": "loc_3xz9nk96",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Croatia",
    "phone": "",
    "email": "hello@enduristan.hr",
    "website": "http://www.enduristan.hr",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 15.6575209,
    "lat": 45.3658443
  },
  {
    "id": "loc_46grp6r5",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Poland",
    "phone": "",
    "email": "info@enduristan.pl",
    "website": "http://www.enduristan.pl",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 19.134422,
    "lat": 52.215933
  },
  {
    "id": "loc_3rep9npq",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Slovakia",
    "phone": "",
    "email": "info@enduristan.cz",
    "website": "http://www.enduristan.cz",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 19.4528646,
    "lat": 48.7411522
  },
  {
    "id": "loc_48zmn9m6",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Romania",
    "phone": "",
    "email": "office@enduristan.ro",
    "website": "http://www.enduristan.ro",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 24.6859225,
    "lat": 45.9852129
  },
  {
    "id": "loc_396mjv6y",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Bulgaria",
    "phone": "",
    "email": "hello@enduristan.bg",
    "website": "https://enduristan.bg/",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 25.4856617,
    "lat": 42.6073975
  },
  {
    "id": "loc_3vzqpgzm",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Israel",
    "phone": "",
    "email": "sales@enduristan.co.il",
    "website": "http://www.enduristan.co.il",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 34.8594762,
    "lat": 30.8124247
  },
  {
    "id": "loc_3qgk7wgy",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Kuwait",
    "phone": "",
    "email": "ali@enduristan-kuwait.com",
    "website": "http://www.enduristan-kuwait.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 47.4979476,
    "lat": 29.2733964
  },
  {
    "id": "loc_4y2v7k2v",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "India",
    "phone": "",
    "email": "info@enduristan.in",
    "website": "http://www.enduristan.in",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 78.6677428,
    "lat": 22.3511148
  },
  {
    "id": "loc_4pkjnpkk",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Thailand",
    "phone": "",
    "email": "sales@enduristan.in.th",
    "website": "http://www.enduristan.in.th",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 100.83273,
    "lat": 14.8971921
  },
  {
    "id": "loc_4n8jpq85",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Vietnam",
    "phone": "",
    "email": "xinchaobiker@enduristan.vn",
    "website": "http://www.enduristan.vn",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 107.9650855,
    "lat": 15.9266657
  },
  {
    "id": "loc_325x9659",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Indonesia",
    "phone": "",
    "email": "sales@enduristanindonesia.com",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 117.8902853,
    "lat": -2.4833826
  },
  {
    "id": "loc_4wk7w5kx",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Malaysia",
    "phone": "",
    "email": "hello@enduristan.my",
    "website": "https://enduristan.my",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 102.2656823,
    "lat": 4.5693754
  },
  {
    "id": "loc_3ezwjnzv",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "South Korea",
    "phone": "",
    "email": "hello@enduristan-korea.com",
    "website": "http://www.enduristan-korea.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 127.6961188,
    "lat": 36.638392
  },
  {
    "id": "loc_3jxg95xe",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Australia",
    "phone": "",
    "email": "gidday@enduristan.com.au",
    "website": "http://www.enduristan.com.au",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 134.755,
    "lat": -24.7761086
  },
  {
    "id": "loc_3g8g6e87",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Japan",
    "phone": "",
    "email": "",
    "website": "http://www.enduristan.jp",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-ch.csv",
      "stockist-locations-eu.csv"
    ],
    "lng": 139.2394179,
    "lat": 36.5748441
  },
  {
    "id": "loc_476nyj8q",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Guatemala",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -90.390002,
    "lat": 15.605589
  },
  {
    "id": "loc_39men69y",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "El Salvador",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -88.866511,
    "lat": 13.736897
  },
  {
    "id": "loc_3vqyezxm",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Honduras",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -86.921641,
    "lat": 14.761664
  },
  {
    "id": "loc_3qkjrgey",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Nicaragua",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -84.919941,
    "lat": 12.335542
  },
  {
    "id": "loc_4yvne29v",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Costa Rica",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -84.200915,
    "lat": 10.257794
  },
  {
    "id": "loc_4pjerk2k",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Panama",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -80.268175,
    "lat": 8.704735
  },
  {
    "id": "loc_4w7pxkzx",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Cuba",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -79.236672,
    "lat": 21.946872
  },
  {
    "id": "loc_4njn28w5",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Ecuador",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -78.432915,
    "lat": -1.160171
  },
  {
    "id": "loc_32xvz5j9",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Peru",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -75.311132,
    "lat": -10.151093
  },
  {
    "id": "loc_3ewe8zmv",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Colombia",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -73.129056,
    "lat": 3.065088
  },
  {
    "id": "loc_3jg82xve",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Chile",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -69.761008,
    "lat": -26.783346
  },
  {
    "id": "loc_3gg7x8z7",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Dominican Republic",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -70.106722,
    "lat": 18.606258
  },
  {
    "id": "loc_45rpvjmn",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Venezuela",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -65.801997,
    "lat": 7.61957
  },
  {
    "id": "loc_3mjwznpv",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Bolivia",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -64.269605,
    "lat": -16.970662
  },
  {
    "id": "loc_3x9wrz76",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Argentinia",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -86.233111,
    "lat": 13.652633
  },
  {
    "id": "loc_4zq2ervw",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Paraguay",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -58.391024,
    "lat": -23.236211
  },
  {
    "id": "loc_4kjyenqq",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Uruguay",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -56.012396,
    "lat": -32.799646
  },
  {
    "id": "loc_46rwqgx5",
    "name": "Enduristan",
    "address1": "",
    "address2": "",
    "city": "",
    "state": "",
    "postal": "",
    "country": "Brazil",
    "phone": "",
    "email": "hola@enduristan-latam.com",
    "website": "http://www.enduristan-latam.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": false,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -51.619789,
    "lat": -9.588903
  },
  {
    "id": "loc_39men6zy",
    "name": "Enduristan",
    "address1": "Rua da Liberdade Nr. 80 Perofilho",
    "address2": "",
    "city": "Santarem",
    "state": "",
    "postal": "2005-008",
    "country": "Portugal",
    "phone": "+351 243 499 255",
    "email": "vendas@in-parts.com",
    "website": "http://www.in-parts.com",
    "notes": "",
    "priority": "",
    "dealer": false,
    "distributor": true,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": -8.7247833,
    "lat": 39.1879634
  },
  {
    "id": "loc_48zmnjp6",
    "name": "Allroadmoto COMMV",
    "address1": "Vlaamse Staak 1 BUS 9",
    "address2": "",
    "city": "Opwijk",
    "state": "",
    "postal": "1745",
    "country": "Belgium",
    "phone": "003252579033",
    "email": "info@allroadmoto.be",
    "website": "http://www.allroadmoto.be",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 4.1501355,
    "lat": 50.971711
  },
  {
    "id": "loc_jzqkw2qe",
    "name": "Motobox",
    "address1": "Via Volpiano, 29",
    "address2": "",
    "city": "Leinì",
    "state": "",
    "postal": "10040",
    "country": "Italy",
    "phone": "+39 011 9989596",
    "email": "info@motobox.biz",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 7.7395011,
    "lat": 45.1867658
  },
  {
    "id": "loc_5zg9evgn",
    "name": "OFF-STORE fuoristrada sempre",
    "address1": "Via Monsignor Bolla 1",
    "address2": "",
    "city": "Moncalvo",
    "state": "AT",
    "postal": "14036",
    "country": "Italy",
    "phone": "+393482436795",
    "email": "stefanosteffenini@off-store.eu",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 8.26657,
    "lat": 45.04927
  },
  {
    "id": "loc_kkp8zepq",
    "name": "UP!TRAIL Modena",
    "address1": "Via Lorenzo Perosi, 71",
    "address2": "",
    "city": "Modena",
    "state": "",
    "postal": "41122",
    "country": "Italy",
    "phone": "+39 392 534 3674",
    "email": "",
    "website": "",
    "notes": "Punto vendita aperto solo su appuntamento",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 10.9534851,
    "lat": 44.6367407
  },
  {
    "id": "loc_ex96njnv",
    "name": "Area Moto",
    "address1": "Via Prà Bordoni, 23",
    "address2": "",
    "city": "Zanè",
    "state": "VI",
    "postal": "36010",
    "country": "Italy",
    "phone": "+390445 314873",
    "email": "info@areamoto.com",
    "website": "http://www.areamoto.com",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 11.4453224,
    "lat": 45.7205345
  },
  {
    "id": "loc_6jmveqm5",
    "name": "Legend Bike",
    "address1": "Viale Arnaldo Fusinato, 12",
    "address2": "",
    "city": "Vicenza",
    "state": "",
    "postal": "36100",
    "country": "Italy",
    "phone": "+39 0444 541002",
    "email": "info@legendbikesas.net",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 11.5443868,
    "lat": 45.5399772
  },
  {
    "id": "loc_rx7vgr7q",
    "name": "Moto Adventure di Chiarabini Gabriele",
    "address1": "Via Respighi, 1",
    "address2": "",
    "city": "Montevarchi",
    "state": "Arezzo",
    "postal": "52025",
    "country": "Italy",
    "phone": "+39 055 0741 262",
    "email": "info@moto-adventure.it",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 11.5657576,
    "lat": 43.5284226
  },
  {
    "id": "loc_7vzq5pqq",
    "name": "Belletti Moto",
    "address1": "Via Savio, 1619",
    "address2": "",
    "city": "Cesena FC",
    "state": "",
    "postal": "47522",
    "country": "Italy",
    "phone": "+39 0547 33663",
    "email": "info@bellettimoto.com",
    "website": "",
    "notes": "Conc. Yamaha",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 12.2297758,
    "lat": 44.1382856
  },
  {
    "id": "loc_v52rwkrm",
    "name": "East Coast Rider",
    "address1": "Via dei Tigli, 1",
    "address2": "",
    "city": "Cesenatico",
    "state": "FC",
    "postal": "47042",
    "country": "Italy",
    "phone": "+39 347 572 2854",
    "email": "info@eastcoastrider.it",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 12.3611757,
    "lat": 44.1840728
  },
  {
    "id": "loc_qx69y29y",
    "name": "Magazzini Rossi",
    "address1": "Viale Angelico 7",
    "address2": "",
    "city": "Roma",
    "state": "RM",
    "postal": "00195",
    "country": "Italy",
    "phone": "+390637514755",
    "email": "",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 12.4578909,
    "lat": 41.9118686
  },
  {
    "id": "loc_p7zx85xk",
    "name": "Elettronica in Moto",
    "address1": "Via Bonconte da Montefeltro, 118",
    "address2": "",
    "city": "Urbino",
    "state": "PU",
    "postal": "61029",
    "country": "Italy",
    "phone": "+390722680710",
    "email": "info@elettronicainmoto.it",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 12.6315707,
    "lat": 43.7386394
  },
  {
    "id": "loc_wgjmnrmx",
    "name": "Motostrom",
    "address1": "Via Largo Centro Studi, 11",
    "address2": "",
    "city": "Morciano di Romagna",
    "state": "",
    "postal": "47833",
    "country": "Italy",
    "phone": "+39 0541 857848",
    "email": "info@motostorm.it",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 12.650704,
    "lat": 43.916995
  },
  {
    "id": "loc_3qmk2n9y",
    "name": "mc-traveler Store",
    "address1": "Vallbytorpsvägen 43-0",
    "address2": "",
    "city": "Klagstorp",
    "state": "Anderslöv",
    "postal": "231 97",
    "country": "Sweden",
    "phone": "+46 79 33 37 473",
    "email": "shop@mc-traveler.com",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 13.353381,
    "lat": 55.386411
  },
  {
    "id": "loc_nxgkz5k5",
    "name": "Holeshot Moto Di Guido Passarelli",
    "address1": "Via Vittoria Nenni, 12",
    "address2": "",
    "city": "Ancona",
    "state": "",
    "postal": "60127",
    "country": "Italy",
    "phone": "+39 071 2415556 / +39 3282662451",
    "email": "info@holeshotmoto.it",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 13.5017062,
    "lat": 43.5974101
  },
  {
    "id": "loc_eq596g9v",
    "name": "Motoricambi C.I.R.",
    "address1": "Via Civiltà del Lavoro, 63 Bis",
    "address2": "",
    "city": "Ortona",
    "state": "",
    "postal": "66026",
    "country": "Italy",
    "phone": "+39 085 421 3172",
    "email": "info@motoricambicir.it",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 14.4010221,
    "lat": 42.3442625
  },
  {
    "id": "loc_gpkq95q7",
    "name": "Motorland by Arpax",
    "address1": "Via G.Amendola 7/9/11",
    "address2": "",
    "city": "Barcellona P.G",
    "state": "Messina",
    "postal": "98051",
    "country": "Italy",
    "phone": "+39 3427610720",
    "email": "info@motorland-at.it",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 15.303437,
    "lat": 37.876898
  },
  {
    "id": "loc_3eyxn8pv",
    "name": "Luddes Garage",
    "address1": "Lövbergsvägen 1G",
    "address2": "",
    "city": "Norrköping",
    "state": "Östergötland",
    "postal": "60591",
    "country": "Sweden",
    "phone": "+46 (0)760 188150",
    "email": "luddesgarage@gmail.com",
    "website": "https://goo.gl/maps/EoGjG6bVnQVtZpgFA",
    "notes": "FB: facebook.com/LuddesGarage\nIG: @luddesgarage",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 16.3098643,
    "lat": 58.5773233
  },
  {
    "id": "loc_3qnmryyy",
    "name": "Storm Motor Turku",
    "address1": "Lukkosepänkatu 4",
    "address2": "",
    "city": "Turku",
    "state": "",
    "postal": "20320",
    "country": "Finland",
    "phone": "+358753265000",
    "email": "info@storm-motor.fi",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 22.20715,
    "lat": 60.4706072
  },
  {
    "id": "loc_3x9v2556",
    "name": "Makan TRT",
    "address1": "Sfaktirias 6",
    "address2": "",
    "city": "Athens",
    "state": "",
    "postal": "10435",
    "country": "Greece",
    "phone": "+030 210 52 47 675",
    "email": "info@makan.gr",
    "website": "http://www.makan.gr",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 23.7168623,
    "lat": 37.982054
  },
  {
    "id": "loc_4kj9zppq",
    "name": "Outduro",
    "address1": "Vienības gatve 38a",
    "address2": "",
    "city": "Riga",
    "state": "",
    "postal": "1004",
    "country": "Latvia",
    "phone": "+37122462780",
    "email": "info@outduro.com",
    "website": "http://www.outduro.com",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 24.0913445,
    "lat": 56.9264354
  },
  {
    "id": "loc_46k227x5",
    "name": "SanLab OÜ",
    "address1": "Allika tee 7",
    "address2": "",
    "city": "Peetri alevik",
    "state": "Harju maakond",
    "postal": "75312",
    "country": "Estonia",
    "phone": "+3726212625",
    "email": "",
    "website": "http://www.motokaup.ee",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 24.8220536,
    "lat": 59.3910322
  },
  {
    "id": "loc_4yqye88v",
    "name": "Storm Motor Vantaa",
    "address1": "Antaksentie 4",
    "address2": "",
    "city": "Vantaa",
    "state": "",
    "postal": "01510",
    "country": "Finland",
    "phone": "+358753265000",
    "email": "info@storm-motor.fi",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-eu.csv"
    ],
    "lng": 24.9478923,
    "lat": 60.2940384
  },
  {
    "id": "loc_yw95m79v",
    "name": "MX1West",
    "address1": "427 Aaron St, Ste A",
    "address2": "",
    "city": "Cotati",
    "state": "California",
    "postal": "94931",
    "country": "USA",
    "phone": "+1-707-664-9089",
    "email": "sales@mx1west.com",
    "website": "http://www.mx1west.com",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-usa.csv"
    ],
    "lng": -122.714352,
    "lat": 38.3404677
  },
  {
    "id": "loc_nxrqqx75",
    "name": "KTM Twins",
    "address1": "1415 Montiel Rd",
    "address2": "",
    "city": "Escondido",
    "state": "California",
    "postal": "92026",
    "country": "USA",
    "phone": "+1 760-313-7313",
    "email": "orders@ktmtwins.com",
    "website": "https://ktmtwins.com/",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-usa.csv"
    ],
    "lng": -117.1099463,
    "lat": 33.1288882
  },
  {
    "id": "loc_6j7665q5",
    "name": "Vamoose Gear Powersports",
    "address1": "1912 South Townsend Avenue",
    "address2": "",
    "city": "Montrose",
    "state": "Colorado",
    "postal": "81401",
    "country": "USA",
    "phone": "+1 970-765-8950",
    "email": "customerservice@vamoosegear.com",
    "website": "https://vamoosegear.com/",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-usa.csv"
    ],
    "lng": -107.8663996,
    "lat": 38.4655354
  },
  {
    "id": "loc_xg6kkjr6",
    "name": "Slavens Racing",
    "address1": "2410 Executive Circle",
    "address2": "",
    "city": "Colorado Springs",
    "state": "Colorado",
    "postal": "80906",
    "country": "USA",
    "phone": "+1 719-475-2624",
    "email": "info@slavensracing.com",
    "website": "https://slavensracing.com/",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-usa.csv"
    ],
    "lng": -104.7887542,
    "lat": 38.7918679
  },
  {
    "id": "loc_rx662wnq",
    "name": "BMW Motorcycle Owners of America, Inc.",
    "address1": "2350 SC-101S",
    "address2": "",
    "city": "Greer",
    "state": "South Carolina",
    "postal": "29651",
    "country": "USA",
    "phone": "+1 864 438-0962",
    "email": "",
    "website": "https://bmwmoa.org/",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-usa.csv"
    ],
    "lng": -82.226885,
    "lat": 34.938585
  },
  {
    "id": "loc_kkgp2n9q",
    "name": "ADV Motorrad",
    "address1": "619 Phillips Rd unit 4",
    "address2": "",
    "city": "Webster",
    "state": "NY",
    "postal": "14580-9760",
    "country": "USA",
    "phone": "+1 585-310-2386",
    "email": "sales@advmotorrad.com",
    "website": "http://advmotorrad.com",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-usa.csv"
    ],
    "lng": -77.4211998,
    "lat": 43.2336781
  },
  {
    "id": "loc_qxe927ey",
    "name": "Terry Davis Offroad",
    "address1": "2 Davis Road",
    "address2": "",
    "city": "Wellsboro",
    "state": "Pennsylvania",
    "postal": "16901",
    "country": "USA",
    "phone": "+1 570 439-3356",
    "email": "Vintage@PTD.net",
    "website": "http://Terrydavisoffroad.com",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-usa.csv"
    ],
    "lng": -77.29929,
    "lat": 41.774132
  },
  {
    "id": "loc_9yzz95ky",
    "name": "Velocity Sports Group",
    "address1": "243 Amesbury Road",
    "address2": "Unit 5",
    "city": "Kensington",
    "state": "NH",
    "postal": "03833",
    "country": "USA",
    "phone": "",
    "email": "",
    "website": "",
    "notes": "",
    "priority": "",
    "dealer": true,
    "distributor": false,
    "visible": true,
    "sources": [
      "stockist-locations-usa.csv"
    ],
    "lng": -70.9254123,
    "lat": 42.9044751
  }
];
